import { useEffect } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function applyContent({ business, content }) {
  const values = { ...content, ...Object.fromEntries(Object.entries(business).filter(([, v]) => v)) };
  document.querySelectorAll("[data-kt]").forEach((el) => {
    const v = values[el.dataset.kt];
    if (v) el.textContent = v;
  });
  document.querySelectorAll("[data-kt-row]").forEach((row) => {
    row.hidden = !business[row.dataset.ktRow];
  });
}

function wireForm(form) {
  const started = Date.now();
  const status = form.querySelector(".form-status");
  const button = form.querySelector("button[type=submit]");
  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }
    const fd = new FormData(form);
    const body = Object.fromEntries(fd.entries());
    body.privacy_ack = fd.get("privacy_ack") === "on";
    body.marketing_consent = fd.get("marketing_consent") === "on";
    body.type = form.dataset.ktForm;
    body.elapsed_ms = Date.now() - started;
    button.disabled = true;
    status.className = "form-status";
    status.textContent = "Sending…";
    try {
      const res = await fetch(`${API}/public/enquiries`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        const d = data.detail;
        throw new Error(Array.isArray(d) ? "Please check the highlighted details and try again." : d || "Something went wrong.");
      }
      form.reset();
      status.className = "form-status ok";
      status.textContent =
        body.type === "appointment"
          ? "Thank you. Your appointment request has been received and we will be in touch to confirm."
          : "Thank you. Your enquiry has been received and we will reply soon.";
    } catch (err) {
      status.className = "form-status err";
      status.textContent = err.message;
    } finally {
      button.disabled = false;
    }
  });
}

export const SiteEnhancer = () => {
  useEffect(() => {
    document.querySelectorAll("form[data-kt-form]").forEach(wireForm);
    fetch(`${API}/public/site`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => d && applyContent(d))
      .catch(() => {});
    // close open menus / dropdowns after navigating to another page
    const closeMenus = () => document.querySelectorAll("#kt-site details[open]:not(.journey-faq):not(.faq details)").forEach((d) => {
      if (d.querySelector("a[href^='#page-']")) d.removeAttribute("open");
    });
    window.addEventListener("hashchange", closeMenus);
    const onClick = (e) => {
      const a = e.target.closest("#kt-site a");
      if (a && /speak to us/i.test(a.textContent) || e.target.closest("[data-kt-book]")) {
        e.preventDefault();
        window.dispatchEvent(new Event("kt-open-booking"));
        return;
      }
      if (e.target.closest("#kt-site details a[href^='#page-']")) setTimeout(closeMenus, 0);
    };
    document.addEventListener("click", onClick);
    // Book page: the old request form is replaced by the booking pop-up
    document.querySelectorAll("form[data-kt-form='appointment']").forEach((f) => {
      const cta = document.createElement("div");
      cta.className = "kb-cta";
      cta.innerHTML = '<h3>Request a free consultation</h3><p>Choose a telephone or Google Meet video call and pick a time that suits you. We confirm every request by email.</p>' +
        '<button type="button" class="btn dark" data-kt-book data-testid="book-page-open-booking">Choose a time ↗</button>';
      f.replaceWith(cta);
    });
    return () => { window.removeEventListener("hashchange", closeMenus); document.removeEventListener("click", onClick); };
  }, []);
  return null;
};
